import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import Lottie from 'react-lottie-player';
import Tree from '../../../../assets/tree/tree.svg';
import SpiralImg from '../../../../assets/tree/spiral.png';
import TreeHouseLetsgoIcon from '../../../../assets/tree/treehouse-letsgo-with-stars.png';
import Door from '../../../../assets/tree/door.svg';
import DoorOpen from '../../../../assets/tree/door-open.svg';
import RoundWindow from '../../../../assets/tree/round-window.svg';
import RoundWindow1 from '../../../../assets/images/round-window-1st.svg';
import RoundWindow2 from '../../../../assets/images/round-window-2nd.svg';
import MapBg from '../../../../assets/images/map-bg.svg';
import SpaceThemeImg from '../../../../assets/images/sky-bg.png';
import './kids-room-taletree.css';
import { useAuth } from '../../../auth/Auth';
import TreeInterestBranches from './TreeInterestBranches';
import { getKidsCompanionImg } from '../../../../utils/companion.utils';
import TreeCreations from './TreeCreations';
import TreeSideButtons from './TreeSideButtons';
import { TREEHOUSE_ROUTE } from '../../../../constants/routes.constants';
import loaderJson from '../../../../assets/json/Loader.json';
import DoorStarsImg from '../../../../assets/tree/Door_Star.png';
import TreeShareButton from './TreeShareButton';

const GuardianTaleTree = ({
  branchesList,
  isMyRoom = false,
  creator = {},
  acceptedChallenges = [],
  showAddButtons = false,
  isTreePage = false,
  kidsData = {},
  setShowAnimation,
  updatedBranches = [],
}) => {
  const { dependent, guardian, school, partner } = useAuth();
  const history = useHistory();
  const [playLoader, setPlayLoader] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  const onTaletreeTreehouseClick = () => {
    if (window.location.hostname === 'taletree.com') {
      history.push(`${TREEHOUSE_ROUTE}/taletree`);
    }
  };

  const setImageLoadedFun = () => {
    setTimeout(() => {
      setShowLoader(false);
      setPlayLoader(false);
      if (setShowAnimation) {
        setShowAnimation(true);
      }
    }, 2000);
  };

  return (
    <Box
      sx={{
        height: 'auto',
        width: '100%',
        background: '#141739',
        overflow: 'auto',
      }}
    >
      {!branchesList.length ? (
        <div
          className="map-loader"
          style={{
            position: isTreePage ? 'fixed' : 'unset',
            display: showLoader ? '' : 'none',
            backgroundImage: `url(${SpaceThemeImg})`,
            backgroundColor: 'unset',
            zIndex: 9999,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <Lottie
            loop={true}
            play={playLoader}
            animationData={loaderJson}
            className="map-loader-in"
          />
        </div>
      ) : (
        <Box
          sx={{ backgroundImage: MapBg, minWidth: '100% !important' }}
          className="kids-room-taletree home_login_tree"
        >
          <Box
            component="img"
            className="tree-img"
            src={Tree}
            onLoad={setImageLoadedFun}
          />
          {/* Door positioned absolutely over the background */}
          <Box className="door">
            <Box
              component="img"
              src={Door}
              alt="Door-Close"
              // className="door-close"
              sx={{
                position: 'absolute',
                top: '77.5%',
                left: '47.92%',
                width: '4.5%',
                height: 'auto',
              }}
            />
          </Box>
          {/* Hangline positioned absolutely over the background */}
          {/* <TreeCreations
          kidId={kidsData?.id}
          acceptedChallenges={acceptedChallenges}
          isGuardianDashboard={true}
        /> */}
          <Box className="Win_box1">
            <Box
              component="img"
              src={RoundWindow}
              alt="window"
              // className="Win_img1"
              sx={{
                top: '57.3%',
                position: 'absolute',
                left: '51.8%',
                width: '2.1%',
              }}
            />
          </Box>
          <Box className="Win_box2">
            <Box
              component="img"
              src={RoundWindow}
              alt="window"
              // className="Win_img2"
              sx={{
                top: '66.5%',
                position: 'absolute',
                left: '47.8%',
                width: '2.8%',
              }}
            />
          </Box>
          <TreeInterestBranches
            branchesList={branchesList}
            updatedBranches={updatedBranches}
            isGuardianDashboard={true}
          />
          <Box component="img" className="spiral-img" src={SpiralImg} />
          {showAddButtons && <TreeSideButtons dependent={dependent} />}
          {showAddButtons && <TreeShareButton dependent={dependent} />}
        </Box>
      )}
    </Box>
  );
};

export default GuardianTaleTree;
